import styled, { createGlobalStyle } from 'styled-components';

export const FormContainer = styled.div`
  width: 60%;
  margin: 40px auto;
`;
